import AuthError from './AuthError.view';

export default AuthError;
